// import React, { useState } from "react";
// import "./Contact.css";

// const Contact = () => {
//   // State for Contact Us form
//   const [contactForm, setContactForm] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });
//   const [contactStatus, setContactStatus] = useState("");

//   // State for Become a Partner form
//   const [partnerForm, setPartnerForm] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });
//   const [partnerStatus, setPartnerStatus] = useState("");

//   // Handle change for both forms using form name
//   const handleChange = (e, formType) => {
//     const { name, value } = e.target;
//     if (formType === "contact") {
//       setContactForm((prev) => ({ ...prev, [name]: value }));
//     } else {
//       setPartnerForm((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//    const handlePartnerSubmit = async (e) => {
//     e.preventDefault();
//     setPartnerStatus(""); // Clear old message

//     try {
//       const response = await fetch(process.env.REACT_APP_API_URL+"/adminpatnertouch", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(partnerForm),
//       });
// console.log("Response status:", response.status);
// console.log("Response body:", await response.text());
//       if (response.ok) {
//         setPartnerStatus("✅ Message sent successfully!");
//         setPartnerForm({ name: "", email: "", message: "" });
//       } else {
//         setPartnerStatus("❌ Failed to send message. Try again.");
//       }
//     } catch (error) {
//       console.error("Partner form error:", error);
//       setPartnerStatus("⚠ Server error. Please try later.");
//     }
//   };

//   // Submit handler for Contact Us form
//   const handleContactSubmit = async (e) => {
//     e.preventDefault();
//     setContactStatus(""); // Clear old message

//     try {
//       const response = await fetch(process.env.REACT_APP_API_URL+"/home", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(contactForm),
//       });

//       if (response.ok) {
//         setContactStatus("✅ Message sent successfully!");
//         setContactForm({ name: "", email: "", message: "" });
//       } else {
//         setContactStatus("❌ Failed to send message. Try again.");
//       }
//     } catch (error) {
//       console.error("Contact form error:", error);
//       setContactStatus("⚠ Server error. Please try later.");
//     }
//   };

//   // Submit handler for Become a Partner form
 
//   return (
//     <section className="partners-section">
//       {/* ===== BEING PARTNERS ===== */}
//       <h2 className="partners-heading">Being Partners</h2>
//       <p className="partners-subtitle">
//         Join hands with us and be a part of the growing drone ecosystem.
//       </p>

//       {/* Partner Cards */}
//       <div className="partners-grid">
//         <div className="partner-card">
//           <div className="partner-icon">🤝</div>
//           <h3>Collaboration</h3>
//           <p>Work with us on projects and research initiatives to shape the future of drone technology.</p>
//         </div>
//         <div className="partner-card">
//           <div className="partner-icon">💼</div>
//           <h3>Business Growth</h3>
//           <p>Expand your opportunities by partnering with us for commercial and industrial drone solutions.</p>
//         </div>
//         <div className="partner-card">
//           <div className="partner-icon">🎓</div>
//           <h3>Knowledge Sharing</h3>
//           <p>Conduct workshops, share expertise, and empower the next generation of drone professionals.</p>
//         </div>
//         <div className="partner-card">
//           <div className="partner-icon">🌍</div>
//           <h3>Global Network</h3>
//           <p>Be part of our international partner ecosystem and gain worldwide visibility.</p>
//         </div>
//       </div>

//       {/* Become a Partner Form */}
//       <div className="partner-form-container">
//         <h3 className="form-title">Become a Partner</h3>
//         <form className="partner-form" onSubmit={handlePartnerSubmit}>
//           <input
//             type="text"
//             name="name"
//             placeholder="Your Name"
//             value={partnerForm.name}
//             onChange={(e) => handleChange(e, "partner")}
//             required
//           />
//           <input
//             type="email"
//             name="email"
//             placeholder="Your Email"
//             value={partnerForm.email}
//             onChange={(e) => handleChange(e, "partner")}
//             required
//           />
//           <textarea
//             name="message"
//             placeholder="Tell us about your partnership idea..."
//             value={partnerForm.message}
//             onChange={(e) => handleChange(e, "partner")}
//             rows="4"
//             required
//           />
//           <button type="submit">Submit</button>
//         </form>
//         {partnerStatus && <p className="form-status">{partnerStatus}</p>}
//       </div>

//       {/* Contact Section */}
//       <div className="contact-page">
//         <h2 className="contact-title">Contact Us</h2>
//         <p className="contact-subtitle">Get in touch with us for any queries or support.</p>

//         <div className="contact-grid">
//           {/* Left Section - Map */}
//           <div className="contact-left">
//             <div className="map-container">
//               <iframe
//                 title="Flytutor Location"
//                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3912.113137918836!2d78.0272093!3d11.326440500000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babdbb297734803%3A0xd05a3e9e2582d7b4!2sFlytutor%20RPTO%20Training%20Cente!5e0!3m2!1sen!2sin!4v1756737038335!5m2!1sen!2sin"
//                 width="100%"
//                 height="350"
//                 style={{ border: 0, borderRadius: "8px" }}
//                 allowFullScreen=""
//                 loading="lazy"
//                 referrerPolicy="no-referrer-when-downgrade"
//               ></iframe>
//             </div>
//           </div>

//           {/* Right Section - Contact Form */}
//           <div className="contact-right">
//             <h3>Send a Message</h3>
//             <form onSubmit={handleContactSubmit}>
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Full Name"
//                 value={contactForm.name}
//                 onChange={(e) => handleChange(e, "contact")}
//                 required
//               />
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Email Address"
//                 value={contactForm.email}
//                 onChange={(e) => handleChange(e, "contact")}
//                 required
//               />
//               <textarea
//                 name="message"
//                 placeholder="Your message..."
//                 value={contactForm.message}
//                 onChange={(e) => handleChange(e, "contact")}
//                 required
//               ></textarea>
//               <button type="submit" className="contact-btn">Send Message</button>
//             </form>
//             {contactStatus && <p className="form-status">{contactStatus}</p>}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;

import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  // ====== State Management ======
  const [contactForm, setContactForm] = useState({ name: "", email: "", message: "" });
  const [contactStatus, setContactStatus] = useState("");

  const [partnerForm, setPartnerForm] = useState({ name: "", email: "", message: "" });
  const [partnerStatus, setPartnerStatus] = useState("");

  // ====== Handle Input Changes ======
  const handleChange = (e, formType) => {
    const { name, value } = e.target;
    if (formType === "contact") {
      setContactForm((prev) => ({ ...prev, [name]: value }));
    } else if (formType === "partner") {
      setPartnerForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  // ====== Submit Partner Form ======
  const handlePartnerSubmit = async (e) => {
    e.preventDefault();
    setPartnerStatus("");

    try {
      const response = await fetch(process.env.REACT_APP_API_URL+"/adminpatnertouch", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(partnerForm),
      });

      if (response.ok) {
        setPartnerStatus("✅ Message sent successfully!");
        setPartnerForm({ name: "", email: "", message: "" });
      } else {
        setPartnerStatus("❌ Failed to send message. Try again.");
      }
    } catch (error) {
      console.error("Partner form error:", error);
      setPartnerStatus("⚠ Server error. Please try later.");
    }
  };

  // ====== Submit Contact Form ======
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactStatus("");

    try {
      const response = await fetch(process.env.REACT_APP_API_URL+"/home", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(contactForm),
      });

      if (response.ok) {
        setContactStatus("✅ Message sent successfully!");
        setContactForm({ name: "", email: "", message: "" });
      } else {
        setContactStatus("❌ Failed to send message. Try again.");
      }
    } catch (error) {
      console.error("Contact form error:", error);
      setContactStatus("⚠ Server error. Please try later.");
    }
  };

  return (
    <section className="partners-section">
      {/* ===== BEING PARTNERS ===== */}
      <h2 className="partners-heading">Being Partners</h2>
      <p className="partners-subtitle">
        Join hands with us and be a part of the growing drone ecosystem.
      </p>

      {/* Partner Cards */}
      <div className="partners-grid">
        <div className="partner-card">
          <div className="partner-icon">🤝</div>
          <h3>Collaboration</h3>
          <p>Work with us on projects and research initiatives to shape the future of drone technology.</p>
        </div>
        <div className="partner-card">
          <div className="partner-icon">💼</div>
          <h3>Business Growth</h3>
          <p>Expand your opportunities by partnering with us for commercial and industrial drone solutions.</p>
        </div>
        <div className="partner-card">
          <div className="partner-icon">🎓</div>
          <h3>Knowledge Sharing</h3>
          <p>Conduct workshops, share expertise, and empower the next generation of drone professionals.</p>
        </div>
        <div className="partner-card">
          <div className="partner-icon">🌍</div>
          <h3>Global Network</h3>
          <p>Be part of our international partner ecosystem and gain worldwide visibility.</p>
        </div>
      </div>

      {/* ===== Become a Partner Form ===== */}
      <div className="partner-form-container">
        <h3 className="form-title">Become a Partner</h3>
        <form className="partner-form" onSubmit={handlePartnerSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={partnerForm.name}
            onChange={(e) => handleChange(e, "partner")}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={partnerForm.email}
            onChange={(e) => handleChange(e, "partner")}
            required
          />
          <textarea
            name="message"
            placeholder="Tell us about your partnership idea..."
            value={partnerForm.message}
            onChange={(e) => handleChange(e, "partner")}
            rows="4"
            required
          />
          <button type="submit">Submit</button>
        </form>
        {partnerStatus && <p className="form-status">{partnerStatus}</p>}
      </div>

      {/* ===== Contact Section ===== */}
      <div className="contact-page">
        <h2 className="contact-title">Contact Us</h2>
        <p className="contact-subtitle">Get in touch with us for any queries or support.</p>

        <div className="contact-grid">
          {/* Left Section - Map */}
          <div className="contact-left">
            <div className="map-container">
              <iframe
                title="Flytutor Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3912.113137918836!2d78.0272093!3d11.326440500000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babdbb297734803%3A0xd05a3e9e2582d7b4!2sFlytutor%20RPTO%20Training%20Cente!5e0!3m2!1sen!2sin!4v1756737038335!5m2!1sen!2sin"
                width="100%"
                height="350"
                style={{ border: 0, borderRadius: "8px" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          {/* Right Section - Contact Form */}
          <div className="contact-right">
            <h3>Send a Message</h3>
            <form onSubmit={handleContactSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={contactForm.name}
                onChange={(e) => handleChange(e, "contact")}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={contactForm.email}
                onChange={(e) => handleChange(e, "contact")}
                required
              />
              <textarea
                name="message"
                placeholder="Your message..."
                value={contactForm.message}
                onChange={(e) => handleChange(e, "contact")}
                rows="4"
                required
              ></textarea>
              <button type="submit" className="contact-btn">Send Message</button>
            </form>
            {contactStatus && <p className="form-status">{contactStatus}</p>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

